import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import { useParams } from 'react-router-dom'
import Editor from 'components/editor'

const EditActionModel = ({ editData, handleRefresh, index, appData, appCollections }) => {

  appCollections = appCollections.filter((data) => data.app_id === appData?.app_id)

  const uploadImage = useUploadImage()
  const AppService = useAppServices()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const { app_id } = useParams
  const [loader, setloader] = useState(true)
  const [user] = useUserInfo()
  var axios = require('axios')

  const handlemodal = () => {
    setOpenAddProduct(true)
  }
  useEffect(async () => { }, [])
  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)
    const [editor, setEditor] = useState(editData?.description || '')

    const handleSubmit = async (e) => {
      e.preventDefault()
      setProcessing(true)
      const actionData = {
        name: e.target.name.value,
        description: editor,
        link: e.target.link.value,
        app_collection_id: e.target.app_collection.value,
      }
      const actions = appData?.actions

      actions[index] = actionData
      const payload = {
        _id: appData._id,
        actions: actions,
      }

      const { response } = await AppService.app.update({
        payload: payload,
      })

      if (response) {
        const payload_collection = {
          app_id: appData.app_id,
          id: e.target.app_collection.value, // Corrected this line
          // also update the trigger value in the app collection
          actions: actions,
        }

        const res = AppService.AppCollections.update({
          payload: payload_collection,
        })

        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const style = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 400,
      height: 'auto',
      overflow: 'auto',
      bgcolor: 'background.paper',
      border: '2px  #000',
      boxShadow: 24,
      p: 4,
    }
    return (
      <MDModal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MDBox>
          <MDBox component="form" onSubmit={handleSubmit} role="form" sx={style}>
            <MDTypography variant="h5" mb={2}>
              App Action
            </MDTypography>
            {/* <MDBox mb={2} ml={1} display="flex" alignItems="center">
              <Stack direction="row" alignItems="center" spacing={2}>
                <Button variant="contained" component="label" sx={{ color: '#fff' }}>
                  Upload Image +
                  <input hidden name="image" type="file" />
                </Button>
              </Stack>
            </MDBox> */}
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Name
              </MDTypography>
              <MDInput label="Name" name="name" fullWidth defaultValue={editData.name} />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Description
              </MDTypography>
              <Editor
                handleChange={(data) => {
                  setEditor(data)
                }}
                data={editor}
              />
            </MDBox>
            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Youtube Link
              </MDTypography>
              <MDInput label="Youtube Link" name="link" fullWidth defaultValue={editData.link} />
            </MDBox>

            <MDBox>
              <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
                Select Actions Category
              </MDTypography>
              <Select label="Actions Category" name="app_collection" fullWidth defaultValue={editData?.app_collection_id}>
                {appCollections.map((data) => (
                  <MenuItem key={data?._id} value={data?._id}>
                    {data?.name}
                  </MenuItem>
                ))}
              </Select>
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={closeAddProduct}
              >
                close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Update
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }
  const closeAddProduct = () => {
    // if (subscription?._id)
    setOpenAddProduct(false)
  }
  return (
    <>
      <MDButton
        variant="contained"
        color="info"
        size="small"
        sx={{ marginLeft: 2 }}
        onClick={handlemodal}
      >
        edit
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default EditActionModel
